import { render, staticRenderFns } from "./AssignCoTeamLeader.vue?vue&type=template&id=30da4412&scoped=true"
import script from "./AssignCoTeamLeader.vue?vue&type=script&lang=js"
export * from "./AssignCoTeamLeader.vue?vue&type=script&lang=js"
import style0 from "./AssignCoTeamLeader.vue?vue&type=style&index=0&id=30da4412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da4412",
  null
  
)

export default component.exports